"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _index = _interopRequireDefault(require("../../../index"));

var _ethereumjsTx = require("ethereumjs-tx");

var _WalletInterface2 = _interopRequireDefault(require("../WalletInterface"));

var _index2 = require("../bip44/index");

var _utils = require("../utils");

var _ethereumjsUtil = require("ethereumjs-util");

var _errorHandler = _interopRequireDefault(require("./errorHandler"));

var _commonGenerator = _interopRequireDefault(require("../helpers/commonGenerator"));

var _misc = _interopRequireDefault(require("../helpers/misc"));

var _debug = _interopRequireDefault(require("debug"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// TODO add debug logging
var debug = (0, _debug.default)('MEWconnect:wallet'); // const debugConnectionState = debugLogger('MEWconnect:connection-state');

var V1_SIGNAL_URL = 'https://connect.mewapi.io';
var V2_SIGNAL_URL = 'wss://connect2.mewapi.io/staging';
var IS_HARDWARE = true;

var MEWconnectWalletInterface = /*#__PURE__*/function (_WalletInterface) {
  _inherits(MEWconnectWalletInterface, _WalletInterface);

  var _super = _createSuper(MEWconnectWalletInterface);

  function MEWconnectWalletInterface(pubkey, isHardware, identifier, txSigner, msgSigner, mewConnect, popUpHandler) {
    var _this;

    _classCallCheck(this, MEWconnectWalletInterface);

    _this = _super.call(this, pubkey, true, identifier);
    _this.errorHandler = (0, _errorHandler.default)(popUpHandler);
    _this.txSigner = txSigner;
    _this.msgSigner = msgSigner;
    _this.isHardware = isHardware;
    _this.mewConnect = mewConnect();
    return _this;
  }

  _createClass(MEWconnectWalletInterface, [{
    key: "getConnection",
    value: function getConnection() {
      return this.mewConnect;
    }
  }, {
    key: "signTransaction",
    value: function signTransaction(txParams) {
      return _get(_getPrototypeOf(MEWconnectWalletInterface.prototype), "signTransaction", this).call(this, txParams, this.txSigner);
    }
  }, {
    key: "signMessage",
    value: function signMessage(msg) {
      return _get(_getPrototypeOf(MEWconnectWalletInterface.prototype), "signMessage", this).call(this, msg, this.msgSigner);
    }
  }]);

  return MEWconnectWalletInterface;
}(_WalletInterface2.default);

var MEWconnectWallet = /*#__PURE__*/function () {
  function MEWconnectWallet(state, popupCreator, popUpHandler) {
    _classCallCheck(this, MEWconnectWallet);

    this.identifier = _index2.MEW_CONNECT;
    this.isHardware = IS_HARDWARE;
    this.mewConnect = new _index.default.Initiator({
      v1Url: V1_SIGNAL_URL,
      v2Url: V2_SIGNAL_URL,
      showPopup: true,
      popupCreator: popupCreator
    });
    this.state = state || {};
    this.popUpHandler = popUpHandler;
    this.txIds = [];
  }

  _createClass(MEWconnectWallet, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var _this2 = this;

        var qrcodeListener,
            txSigner,
            msgSigner,
            mewConnect,
            address,
            _args3 = arguments;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                qrcodeListener = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : function () {};
                this.mewConnect.on('codeDisplay', qrcodeListener);

                txSigner = /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(tx) {
                    var tokenInfo, networkId;
                    return _regenerator.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (tx.data.slice(0, 10) === '0xa9059cbb' || tx.data.slice(0, 10) === '0x095ea7b3') {
                              tokenInfo = _this2.state.network.type.tokens.find(function (entry) {
                                return entry.address.toLowerCase() === tx.to.toLowerCase();
                              });

                              if (tokenInfo) {
                                tx.currency = {
                                  symbol: tokenInfo.symbol,
                                  decimals: tokenInfo.decimals,
                                  address: tokenInfo.address
                                };
                              }
                            }

                            networkId = tx.chainId;
                            return _context.abrupt("return", new Promise(function (resolve, reject) {
                              if (!tx.gasLimit) {
                                tx.gasLimit = tx.gas;
                              }

                              _this2.mewConnect.sendRtcMessage('signTx', JSON.stringify(tx));

                              _this2.mewConnect.once('signTx', function (result) {
                                _this2.mewConnect.removeAllListeners('reject');

                                tx = new _ethereumjsTx.Transaction((0, _utils.sanitizeHex)(result), {
                                  common: (0, _commonGenerator.default)(_this2.state.network.type)
                                });
                                var signedChainId = (0, _utils.calculateChainIdFromV)(tx.v);
                                if (signedChainId !== networkId) throw new Error('Invalid networkId signature returned. Expected: ' + networkId + ', Got: ' + signedChainId, 'InvalidNetworkId');
                                resolve((0, _utils.getSignTransactionObject)(tx));
                              });

                              _this2.mewConnect.once('reject', function () {
                                debug('signTx rejected');

                                _this2.mewConnect.removeAllListeners('signTx');

                                reject({
                                  reject: true
                                });
                              });
                            }));

                          case 3:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function txSigner(_x) {
                    return _ref.apply(this, arguments);
                  };
                }();

                msgSigner = /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2(msg) {
                    return _regenerator.default.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            return _context2.abrupt("return", new Promise(function (resolve, reject) {
                              var msgHash = (0, _ethereumjsUtil.hashPersonalMessage)(_misc.default.toBuffer(msg));

                              _this2.mewConnect.sendRtcMessage('signMessage', {
                                hash: msgHash.toString('hex'),
                                text: msg
                              });

                              _this2.mewConnect.once('signMessage', function (data) {
                                _this2.mewConnect.removeAllListeners('reject');

                                resolve((0, _utils.getBufferFromHex)((0, _utils.sanitizeHex)(data.sig)));
                              });

                              _this2.mewConnect.once('reject', function () {
                                debug('signMessage rejected');

                                _this2.mewConnect.removeAllListeners('signMessage');

                                reject({
                                  reject: true
                                });
                              });
                            }));

                          case 1:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function msgSigner(_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }();

                mewConnect = function mewConnect() {
                  return _this2.mewConnect;
                };

                _context3.next = 7;
                return signalerConnect(V1_SIGNAL_URL, this.mewConnect);

              case 7:
                address = _context3.sent;
                return _context3.abrupt("return", new MEWconnectWalletInterface((0, _utils.sanitizeHex)(address), this.isHardware, this.identifier, txSigner, msgSigner, mewConnect, this.popUpHandler));

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }], [{
    key: "setConnectionState",
    value: function setConnectionState(connectionState) {
      if (!connectionState) _index.default.Initiator.setConnectionState('disconnected');else _index.default.Initiator.setConnectionState(connectionState);
      debug('setConnectionState', _index.default.Initiator.connectionState);
    }
  }, {
    key: "getConnectionState",
    value: function getConnectionState() {
      debug('getConnectionState', _index.default.Initiator.connectionState);
      if (!_index.default.Initiator.connectionState) return 'disconnected';
      return _index.default.Initiator.connectionState;
    }
  }, {
    key: "getPopupWindowRef",
    value: function getPopupWindowRef() {
      if (!_index.default.Initiator.connectionState) return 'disconnected';
      return _index.default.Initiator.connectionState;
    }
  }]);

  return MEWconnectWallet;
}();

var createWallet = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee4(state, popupCreator, popUpHandler) {
    var _MEWconnectWallet, _tWallet;

    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _MEWconnectWallet = new MEWconnectWallet(state, popupCreator, popUpHandler);
            createWallet.connectionState = _MEWconnectWallet.connectionState;
            _context4.next = 4;
            return _MEWconnectWallet.init();

          case 4:
            _tWallet = _context4.sent;
            return _context4.abrupt("return", _tWallet);

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function createWallet(_x3, _x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();

createWallet.errorHandler = _errorHandler.default;

var signalerConnect = function signalerConnect(url, mewConnect) {
  return new Promise(function (resolve) {
    mewConnect.initiatorStart(url); // future extension
    // mewConnect.on('AuthRejected', () => {
    //   reject();
    // });

    mewConnect.on('RtcConnectedEvent', function () {
      mewConnect.sendRtcMessage('address', '');
      mewConnect.once('address', function (data) {
        resolve(data.address);
      });
    });
    mewConnect.on('RtcDisconnectEvent', function () {
      MEWconnectWallet.setConnectionState('disconnected');
      mewConnect;
    });
  });
};

createWallet.getConnectionState = MEWconnectWallet.getConnectionState;
createWallet.setConnectionState = MEWconnectWallet.setConnectionState;
var _default = createWallet;
exports.default = _default;